import {
  FieldWrapper,
  InputErrorMessage,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { getDaysInMonth, NonTimezoneSensitiveDate } from '@commenda/utils';

export function FiscalDayMonthInput({
  title = 'Fiscal year end',
  value,
  setValue,
  errors,
  disabled = false,
}: {
  title?: string;
  value: { month: string; day: string };
  setValue: (arg0: { month?: string; day?: string }) => unknown;
  errors: { month: string; day: string };
  disabled?: boolean;
}) {
  return (
    <FieldWrapper>
      <Label htmlFor="fiscalYearEnd">
        <span>{title}</span>
        <span className="text-utility-violet-600">*</span>
      </Label>

      <div className="flex gap-2">
        <div className="flex-1 flex flex-col gap-1.5">
          <Select
            value={value.month?.toString()}
            disabled={disabled}
            onValueChange={(updatedValue) => {
              if (updatedValue)
                setValue({
                  ...value,
                  month: updatedValue,
                });
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select month" />
            </SelectTrigger>
            <SelectContent>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month, index) => (
                <SelectItem key={month} value={month.toString()}>
                  {NonTimezoneSensitiveDate.getMonthNames()[index]}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {errors?.month && <InputErrorMessage message={errors?.month} />}
        </div>
        <div className="flex-1 flex flex-col gap-1.5">
          <Select
            value={value.day?.toString()}
            disabled={disabled}
            onValueChange={(updatedValue) => {
              if (updatedValue)
                setValue({
                  ...value,
                  day: updatedValue,
                });
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder="Select day" />
            </SelectTrigger>
            <SelectContent>
              {Array.from(
                new Array(
                  value.month
                    ? getDaysInMonth(parseInt(value.month, 10), 2001)
                    : 31
                )
              ).map((_, idx) => (
                <SelectItem
                  key={(idx + 1).toString()}
                  value={(idx + 1).toString()}
                >
                  {idx + 1}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {errors?.day && <InputErrorMessage message={errors?.day} />}
        </div>
      </div>
    </FieldWrapper>
  );
}
